import { render } from "./JoinBuilder.vue?vue&type=template&id=edb3e4fa"
import script from "./JoinBuilder.vue?vue&type=script&lang=js"
export * from "./JoinBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/JoinBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "edb3e4fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('edb3e4fa', __exports__)) {
    api.reload('edb3e4fa', __exports__)
  }
  
  module.hot.accept("./JoinBuilder.vue?vue&type=template&id=edb3e4fa", () => {
    api.rerender('edb3e4fa', render)
  })

}


export default __exports__